// extracted by mini-css-extract-plugin
module.exports = {"button":"ButtonSimple_button__1vN0z","button--blue":"ButtonSimple_button--blue__1xj-i","button--red":"ButtonSimple_button--red__1ePnm"};